import React from 'react';

import FilePrompt from '../PromptFooter/FilePrompt/FilePrompt';

import './FilePromptComponent.css';

interface FilePromptComponentProps {
  file?: File;
  userInput?: string;
}

/**
 * FilePromptComponent for displaying file and user input in messages
 */
function FilePromptComponent({ file, userInput }: FilePromptComponentProps) {
  return (
    <>
      {file && (
        <div className='FilePromptComponent-Container'>
          <FilePrompt
            file={file}
            isCloseVisible={false}
            isProgressVisible={false}
            uploadProgress={null}
          />
        </div>
      )}
      {userInput && (
        <div className='FilePromptComponent-InputContainer'>
          <div className='FilePromptComponent-InputItem'>{userInput}</div>
        </div>
      )}
    </>
  );
}

FilePromptComponent.defaultProps = {
  file: undefined,
  userInput: undefined,
};

export default FilePromptComponent;
